/// <amd-module name="typeahead/core/StaticDataProvider" />
/// <amd-dependency path="jquery" name="$" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

/// <reference path="../../typings/typeahead/loc.d.ts" />

import {IEssResponse} from "typeahead/core/EssDataProvider";
import {IDataProvider, IDataProviderResponse} from "typeahead/core/IDataProvider";
import {ListItemType} from "typeahead/core/IListItem";
import {IRegionNames, ISuggestionResult} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export interface IStaticDataProviderOptions {
    activeEssTests: string;
    inputElem: JQuery;
    lob: string;
    requestType: string;
    srchText: string;
}

export interface IStaticSuggestionResult extends ISuggestionResult {
    icon: string;
    regionNames: IRegionNames;
    type: string;
}

export interface IStaticResponse extends IDataProviderResponse {}

export interface ICombinedStaticEssResponse extends IStaticResponse, IEssResponse {}

export class StaticDataProvider implements IDataProvider {

    private static getHotelNotFoundStaticSuggestion(): IStaticSuggestionResult {

        let labelText = loc.typeaheadTextHotelNotPresent ? loc.typeaheadTextHotelNotPresent :
            "My hotel/stay is not in this list";
        return {
            category: "DEFAULT",
            icon: "info",
            index: 0 + "",
            listItemType: ListItemType.Suggestion,
            regionNames: {
                displayName: labelText,
                fullName: labelText,
                lastSearchName: labelText,
            },
            type: "HOTELNOTPRESENT",
        };
    }

    private static getStaticSuggestions(options: IStaticDataProviderOptions): IStaticSuggestionResult[] {
        let staticSuggestions: IStaticSuggestionResult[] = [];
        if ("LX.Checkout" === TypeaheadUtils.getClientId() && options.inputElem.attr("id") === "lx-pickup-uta") {
            // Add the LX hotel not found item
            staticSuggestions.push(StaticDataProvider.getHotelNotFoundStaticSuggestion());
        }

        return staticSuggestions;
    }

    private static mergeESSStaticSuggestions(essResponse: IEssResponse, staticResponse: IStaticResponse):
        ICombinedStaticEssResponse {

        let mergedResponse: ICombinedStaticEssResponse = {
            activeABTests: essResponse.activeABTests,
            isReferralToGoogleMaps: essResponse.isReferralToGoogleMaps,
            query: essResponse.query,
            responseCode: essResponse.responseCode,
            results: essResponse.results,
        };

        let essResultLength: number = essResponse.results && essResponse.results.length > 0 ?
            essResponse.results.length : 0;

        mergedResponse = StaticDataProvider.updateCombinedResults(mergedResponse, staticResponse, essResultLength);

        return mergedResponse;
    }

    private static updateCombinedResults(mergedResponse: ICombinedStaticEssResponse, staticResponse: IStaticResponse,
                                         essLength: number): ICombinedStaticEssResponse {
        let startIndex: number = essLength;

        staticResponse.results.forEach((result) => {
            if (startIndex > 0) {
                (result as ISuggestionResult).index = (startIndex++) + "";
            }
            mergedResponse.results = mergedResponse.results.concat(result);
        });

        return mergedResponse;
    }

    // Static suggestions to be appended to ESS response
    public fetchData(options: IStaticDataProviderOptions, essResponse: IEssResponse):
    JQueryPromise<ICombinedStaticEssResponse> {
        let deferred: JQueryDeferred<ICombinedStaticEssResponse> = $.Deferred();
        let staticResponse: IStaticResponse = { results: StaticDataProvider.getStaticSuggestions(options) };

        let mergedResponse: ICombinedStaticEssResponse =
            StaticDataProvider.mergeESSStaticSuggestions(essResponse, staticResponse);
        deferred.resolve(mergedResponse);
        return deferred.promise();
    }
}
